import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	container: {
		width: "100%",
		display: "flex",
		flexFlow: "column"
	},
	portlet: {
		marginTop: "auto",
		marginBottom: "auto"
	},
	chatCoverPage: {
		height: "100%"
	},
	openChatButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
			color: colors.getPrimaryColor()
		},
		alignSelf: "center",
		width: "fit-content",
		margin: "10px"
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	},
	feedbackText: {
		padding: "10px"
	}
})

export default useStyles
